export default __webpack_public_path__ + "static/media/013-swing.83eddcc3.png";